.feedback {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  padding: var(--tuna-spacing-3);
  background: var(--tuna-palette-action-hover);
  border-radius: var(--tuna-shape-radius-md);
  margin-top: var(--tuna-spacing-2);
}

.header {
  margin: 0;
  font-size: var(--tuna-typography-h6-fontSize);
  font-weight: 600;
}

.correct {
  color: var(--tuna-feedback-success);
}

.incorrect {
  color: var(--tuna-feedback-error);
}

.body {
  margin: 0;
  color: var(--tuna-content-primary);
}

.actions {
  display: flex;
  justify-content: space-between;
  gap: var(--tuna-spacing-2);
  margin-top: var(--tuna-spacing-2);
}
